import React from "react";
import { Card } from "@/components/ui/card";
import * as Icons from "lucide-react";

export default function ExternalComingSoon({ icon = "Sparkles", title, note, testid }) {
  const Icon = Icons[icon] || Icons.Sparkles;
  return (
    <div data-testid={testid} className="max-w-2xl">
      <h1 className="font-display text-2xl font-bold text-[#252221] mb-4">{title}</h1>
      <Card className="p-10 border-[#E6EDF2] text-center">
        <span className="mx-auto h-12 w-12 rounded-2xl bg-[#1C4358]/10 text-[#1C4358] flex items-center justify-center"><Icon size={22} /></span>
        <p className="text-[15px] text-muted-foreground mt-3 max-w-md mx-auto">{note}</p>
      </Card>
    </div>
  );
}
